import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessPracticalAndMore } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { canManageAllDocuments } from "./permissions";
import { documentsRoutes } from "./routes";

export const documentsRoute = [
  {
    path: documentsRoutes.rootList,
    lazy: async () => {
      const { DocumentRootListPage } = await import("@/modules/documents/pages/root-list/DocumentsRootListPage");

      return {
        element: (
          <RequireAuth permission={canAccessPracticalAndMore}>
            <DocumentRootListPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: documentsRoutes.rootCreate,
    lazy: async () => {
      const { CreateDocumentRootPage } = await import("@/modules/documents/pages/root-editor/CreateDocumentRootPage");

      return {
        element: (
          <RequireAuth permission={canManageAllDocuments}>
            <CreateDocumentRootPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: documentsRoutes.rootEdit,
    lazy: async () => {
      const { EditDocumentRootPage } = await import("@/modules/documents/pages/root-editor/EditDocumentRootPage");

      return {
        element: (
          <RequireAuth permission={canManageAllDocuments}>
            <EditDocumentRootPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: documentsRoutes.documentsList,
    lazy: async () => {
      const { DocumentsListPage } = await import("@/modules/documents/pages/documents-list/DocumentsListPage");

      return { element: <DocumentsListPage /> };
    },
  },
  {
    path: documentsRoutes.fileCreate,
    lazy: async () => {
      const { CreateDocumentFilePage } = await import("@/modules/documents/pages/file-editor/CreateDocumentFilePage");

      return { element: <CreateDocumentFilePage /> };
    },
  },
  {
    path: documentsRoutes.fileEdit,
    lazy: async () => {
      const { EditDocumentFilePage } = await import("@/modules/documents/pages/file-editor/EditDocumentFilePage");

      return { element: <EditDocumentFilePage /> };
    },
  },
  {
    path: documentsRoutes.folderCreate,
    lazy: async () => {
      const { CreateDocumentFolderPage } =
        await import("@/modules/documents/pages/folder-editor/CreateDocumentFolderPage");

      return { element: <CreateDocumentFolderPage /> };
    },
  },
  {
    path: documentsRoutes.folderEdit,
    lazy: async () => {
      const { EditDocumentFolderPage } = await import("@/modules/documents/pages/folder-editor/EditDocumentFolderPage");

      return { element: <EditDocumentFolderPage /> };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
